export const truncate = (text, max = 40) => {
  if (!text) return ""
  const str = String(text)
  return str.length > max ? `${str.slice(0, max)}…` : str
}

// `ok` rows carry SAP's free-text payload in `msg`; `not_found`/`errored` rows
// carry our adapter's error message in `message`. Pick the right one per row.
export const displayedMessage = (row) => {
  if (!row) return ""
  if (row.outcome === "ok") return row.msg || ""
  return row.message || ""
}
